import { PageBuildStatus } from '../../types';

interface SitePlanChipProps {
  siteName: string | null;
  planName: string | null;
  status?: PageBuildStatus | null;
  onClick?: () => void;
  showTooltip?: boolean;
  size?: 'sm' | 'md';
}

const statusColors: Record<string, string> = {
  PENDING: 'bg-gray-200 dark:bg-gray-700 border-gray-300 dark:border-gray-600',
  QUEUED: 'bg-blue-100 dark:bg-blue-900/40 border-blue-300 dark:border-blue-700',
  IN_PROGRESS: 'bg-yellow-100 dark:bg-yellow-900/40 border-yellow-300 dark:border-yellow-700',
  WAITING_FOR_USER_ACTION: 'bg-orange-100 dark:bg-orange-900/40 border-orange-300 dark:border-orange-700',
  WAITING_FOR_SYSTEM_ACTION: 'bg-purple-100 dark:bg-purple-900/40 border-purple-300 dark:border-purple-700',
  READY_TO_DEPLOY: 'bg-purple-100 dark:bg-purple-900/40 border-purple-300 dark:border-purple-700',
  COMPLETED: 'bg-green-100 dark:bg-green-900/40 border-green-300 dark:border-green-700',
  FAILED: 'bg-red-100 dark:bg-red-900/40 border-red-300 dark:border-red-700',
  CANCELLED: 'bg-gray-200 dark:bg-gray-700 border-gray-300 dark:border-gray-600',
  SKIPPED: 'bg-gray-200 dark:bg-gray-700 border-gray-300 dark:border-gray-600',
  ERROR: 'bg-red-100 dark:bg-red-900/40 border-red-300 dark:border-red-700',
};

export function SitePlanChip({
  siteName,
  planName,
  status,
  onClick,
  showTooltip = true,
  size = 'sm',
}: SitePlanChipProps) {
  const siteInitial = siteName?.[0]?.toUpperCase() || '?';
  const planInitial = planName?.[0]?.toUpperCase() || '?';
  const statusClass = statusColors[status || 'PENDING'] || 'bg-gray-200 dark:bg-gray-700 border-gray-300 dark:border-gray-600';

  const tooltip = showTooltip
    ? `${siteName || 'No site'} / ${planName || 'No plan'}${status ? ` - ${status}` : ''}`
    : undefined;

  const sizeClasses = size === 'sm'
    ? 'px-1.5 py-0.5 text-[10px]'
    : 'px-2 py-1 text-xs';

  const cursorClass = onClick ? 'cursor-pointer hover:opacity-80' : 'cursor-default';

  return (
    <span
      title={tooltip}
      onClick={onClick}
      className={`inline-flex items-center ${sizeClasses} font-medium rounded border ${statusClass} ${cursorClass}`}
    >
      {siteInitial}{planInitial}
    </span>
  );
}
